import { TableCell } from "@mui/material";
import {
  IAdditional,
  IAdditionalHeaderProps,
} from "../../../TableTemplate/tableTemplate";
import Button from "../../../../Components/Button";
import { memo, useState } from "react";
import ChartUI from "./ChartUI";
import Modal from "../../../../Components/Modal/Modal";
import TimelineIcon from "@mui/icons-material/Timeline";
import { IPairPositionReport } from "../../../../Interfaces/optionDomain";
import SendRequestConfig from "./SendRequestConfig";
import SendDeltaOrderRequestConfig from "./DeltahedgeOrder";
import { Edit } from "@mui/icons-material";
import UpdateTarget from "src/Pages/OptionDomain/PairPosition/UpdateTarget";
import { DeltaHedgeOrderType } from "src/Interfaces/deltaHedgeOrder";
import { StepOptionOrderType } from "src/Interfaces/stepInterfaces";

const AdditionalHeader = ({}: IAdditionalHeaderProps) => {
  return (
    <>
      <TableCell>
        <span className="!font-black text-black">سفارش باز</span>
      </TableCell>
      <TableCell />
      <TableCell />
      <TableCell />
    </>
  );
};

enum ModalMode {
  Chart,
  SendConfig,
  Closed,
  NewDeltaHedgeOrder,
  Edit,
}

const AdditionalCol: React.FC<{
  row: IPairPositionReport;
  onAction: () => void;
}> = memo(({ row, onAction }) => {
  const [modalMode, setModalMode] = useState(ModalMode.Closed);

  const getModalUI = () => {
    switch (modalMode) {
      case ModalMode.Chart:
        return <ChartUI row={row} />;
      case ModalMode.SendConfig:
        return <SendRequestConfig row={row} onAction={onAction} />;

      case ModalMode.NewDeltaHedgeOrder:
        return <SendDeltaOrderRequestConfig row={row} onAction={onAction} />;

      case ModalMode.Edit:
        return (
          <UpdateTarget
            instrumentNames={[row.instrumentName1!, row.instrumentName2!]}
            initialValues={{
              deltaHedgeOrderType: DeltaHedgeOrderType.Open,
              newLockProfitTarget: row.openOrder ? Number(row.openOrder) : 0,
              instrumentId1: row.instrumentId1,
              instrumentId2: row.instrumentId2,
              orderSide1: row.orderSideValue1,
              orderSide2: row.orderSideValue2,
              optionOrderType1: StepOptionOrderType.Open,
              optionOrderType2: StepOptionOrderType.Open,
            }}
            onClose={() => setModalMode(ModalMode.Closed)}
            orderTypeStr="ورود"
            onAction={onAction}
          />
        );

      default:
        return <></>;
    }
  };

  const editHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setModalMode(ModalMode.Edit);
  };

  return (
    <>
      <TableCell>
        <div className="flex flex-row justify-start items-center gap-2">
          <div>{row.openOrderExpr || "-"}</div>
          {row.openOrderExpr ? (
            <div
              className="hover:bg-slate-300 transition-all rounded p-1 cursor-pointer"
              onClick={editHandler}
            >
              <Edit className="text-sky-700 cursor-pointer" />
            </div>
          ) : (
            <></>
          )}
        </div>
      </TableCell>
      <TableCell>
        {modalMode !== ModalMode.Closed ? (
          <Modal
            UI={getModalUI()}
            title={
              modalMode === ModalMode.Chart
                ? [row.instrumentName1, row.instrumentName2]
                    .filter(Boolean)
                    .join(" — ") || "نمودار"
                : undefined
            }
            onClose={() => setModalMode(ModalMode.Closed)}
            fullScreen={modalMode === ModalMode.Chart}
            modalBoxClassName={
              modalMode === ModalMode.Chart
                ? "pair-position-chart-modal"
                : ""
            }
          />
        ) : (
          <></>
        )}
        <Button
          text={<TimelineIcon />}
          onClick={() => setModalMode(ModalMode.Chart)}
          variant="contained"
        />
      </TableCell>
      <TableCell>
        <Button
          text="ارسال"
          onClick={() => setModalMode(ModalMode.SendConfig)}
          variant="contained"
        />
      </TableCell>

      <TableCell>
        <Button
          text="ارسال جدید"
          onClick={() => setModalMode(ModalMode.NewDeltaHedgeOrder)}
          variant="contained"
        />
      </TableCell>
    </>
  );
});

export const Additional: IAdditional<IPairPositionReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
